import React from "react";

import Picture from "../components/Navbar Components/Picture";
import NewFarmerForm from "./NewFarmerForm";

const NewFarmer = () => {
  return (
    <>
      <Picture />
      <NewFarmerForm />
    </>
  );
};
export default NewFarmer;